"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateFilter = exports.isUuidField = void 0;
const filter_constants_1 = require("./filter.constants");
const isUuidField = (field, fieldSpecifier) => filter_constants_1.ID_FIELDS.includes(field) || filter_constants_1.ID_FIELDS.includes(fieldSpecifier);
exports.isUuidField = isUuidField;
const isDateFilter = (field) => filter_constants_1.DATE_FIELDS.includes(field);
exports.isDateFilter = isDateFilter;
